import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { usePricingCategories } from '../../hooks';
import type { PricingCategory, PricingCategoryFilters } from '../../models';

export interface PricingCategoryFieldProps extends Omit<SelectProps<PricingCategory>, 'options'> {
  defaultFilters?: Partial<PricingCategoryFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<PricingCategory>['errorMessage'];
  isInvalid?: boolean;
}

export const PricingCategoryField: React.FC<PricingCategoryFieldProps> = ({
  defaultFilters,
  label,
  ...otherFieldProps
}) => {
  const { data, isLoading, updateFilters } = usePricingCategories(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
